import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postAssignToQueue } from '../../requests/postAssignToQueue';
import { AssignQueuePayload } from '../../types/AssignmentQueue';

export const useAssignToQueue = () => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: assignToQueue, ...rest } = useMutation({
    mutationFn: (payload: AssignQueuePayload) =>
      postAssignToQueue(constructPost, payload),
  });

  return { assignToQueue, ...rest };
};
